const cards = [
  {
    title: '奔跑吧 · 第十季',
    tag: '户外竞技',
    desc: '全新一季跑男团再次集结，经典撕名牌回归，笑点与泪点齐飞，每周五晚准时开跑。',
    img: 'https://readdy.ai/api/search-image?query=Dynamic%20outdoor%20adventure%20scene%20with%20group%20of%20people%20running%20through%20colorful%20urban%20landscape%20warm%20sunset%20lighting%20energetic%20motion%20blur%20cinematic%20variety%20show%20poster%20style%20vibrant%20orange%20and%20coral%20tones%20excitement%20and%20teamwork%20atmosphere%20modern%20entertainment%20photography&width=800&height=500&seq=card-01-6080&orientation=landscape',
    badge: '热播中',
  },
  {
    title: '歌手2025',
    tag: '音乐竞演',
    desc: '顶级唱将同台竞技，全新赛制升级，每一期都是视听盛宴，引爆全网音乐话题。',
    img: 'https://readdy.ai/api/search-image?query=Elegant%20music%20stage%20performance%20with%20spotlight%20beams%20and%20floating%20musical%20notes%20dramatic%20lighting%20in%20warm%20golden%20and%20amber%20tones%20professional%20concert%20atmosphere%20with%20microphone%20on%20stand%20soft%20bokeh%20background%20emotional%20singer%20silhouette%20cinematic%20composition&width=800&height=500&seq=card-02-6080&orientation=landscape',
    badge: '热播中',
  },
  {
    title: '密室大逃脱 · 第六季',
    tag: '沉浸解谜',
    desc: '全新密室场景升级，明星嘉宾智商在线，烧脑解谜全程高能，胆小慎入的沉浸式体验。',
    img: 'https://readdy.ai/api/search-image?query=Mysterious%20escape%20room%20setting%20with%20dim%20atmospheric%20lighting%20warm%20candle%20glow%20shadows%20and%20hidden%20doors%20puzzle%20elements%20scattered%20on%20wooden%20table%20suspenseful%20cinematic%20composition%20with%20rich%20brown%20and%20amber%20tones%20immersive%20interior%20photography&width=800&height=500&seq=card-03-6080&orientation=landscape',
    badge: '更新中',
  },
  {
    title: '脱口秀大会 · 第五季',
    tag: '搞笑喜剧',
    desc: '新老脱口秀演员爆笑对决，犀利吐槽加温暖治愈，下班后的最佳解压综艺。',
    img: 'https://readdy.ai/api/search-image?query=Comedy%20club%20stage%20with%20warm%20spotlight%20on%20standup%20microphone%20red%20brick%20wall%20background%20cozy%20atmosphere%20with%20soft%20amber%20lighting%20audience%20silhouettes%20in%20shadow%20laughter%20and%20entertainment%20vibe%20professional%20theater%20photography&width=800&height=500&seq=card-04-6080&orientation=landscape',
    badge: '热播中',
  },
  {
    title: '乘风破浪 · 第四季',
    tag: '励志成长',
    desc: '姐姐们再次集结，突破自我重新出发，用实力证明年龄只是数字，每一场公演都惊艳。',
    img: 'https://readdy.ai/api/search-image?query=Elegant%20stage%20performance%20with%20flowing%20fabric%20and%20dynamic%20dance%20movement%20warm%20golden%20and%20rose%20lighting%20empowering%20feminine%20energy%20professional%20dance%20photography%20soft%20glamorous%20atmosphere%20with%20sparkle%20effects%20modern%20variety%20show%20aesthetic&width=800&height=500&seq=card-05-6080&orientation=landscape',
    badge: '更新中',
  },
];

export default function CardsSection() {
  return (
    <section id="cards" className="w-full py-14 md:py-20 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-8">
        <div className="text-center mb-10">
          <div className="inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full bg-primary-500/10 border border-primary-500/20 mb-4">
            <i className="ri-star-line text-primary-400 text-xs"></i>
            <span className="text-xs text-primary-400 font-medium whitespace-nowrap">编辑精选</span>
          </div>
          <h2 className="font-heading font-bold text-2xl md:text-3xl text-foreground-100 mb-3">
            热门综艺推荐
          </h2>
          <p className="text-sm text-foreground-500 max-w-lg mx-auto">
            精选当前最热播的高分综艺节目，每一档都值得追
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {cards.slice(0, 3).map((card) => (
            <a key={card.title} href="#cards" onClick={(e) => e.preventDefault()} className="group block cursor-pointer">
              <div className="bg-background-100 rounded-xl overflow-hidden border border-background-300/20 transition-all duration-300 hover:border-primary-500/30">
                <div className="relative aspect-[16/10] overflow-hidden">
                  <img
                    src={card.img}
                    alt={card.title}
                    className="w-full h-full object-cover object-center transition-transform duration-500 group-hover:scale-105"
                  />
                  <div className="absolute top-3 left-3">
                    <span className="px-2 py-0.5 bg-primary-500 text-background-50 text-xs font-medium rounded-md whitespace-nowrap">
                      {card.badge}
                    </span>
                  </div>
                  <div className="absolute inset-0 bg-gradient-to-t from-background-100/90 via-transparent to-transparent"></div>
                </div>
                <div className="p-4">
                  <div className="flex items-center gap-2 mb-2">
                    <span className="text-xs text-accent-400 font-medium whitespace-nowrap">{card.tag}</span>
                  </div>
                  <h3 className="font-heading font-bold text-base text-foreground-100 mb-2 group-hover:text-primary-400 transition-colors">
                    {card.title}
                  </h3>
                  <p className="text-xs text-foreground-500 leading-relaxed line-clamp-2">{card.desc}</p>
                </div>
              </div>
            </a>
          ))}
          {cards.slice(3).map((card) => (
            <a key={card.title} href="#cards" onClick={(e) => e.preventDefault()} className="group hidden lg:block cursor-pointer">
              <div className="bg-background-100 rounded-xl overflow-hidden border border-background-300/20 transition-all duration-300 hover:border-primary-500/30">
                <div className="relative aspect-[16/10] overflow-hidden">
                  <img
                    src={card.img}
                    alt={card.title}
                    className="w-full h-full object-cover object-center transition-transform duration-500 group-hover:scale-105"
                  />
                  <div className="absolute top-3 left-3">
                    <span className="px-2 py-0.5 bg-accent-500 text-background-50 text-xs font-medium rounded-md whitespace-nowrap">
                      {card.badge}
                    </span>
                  </div>
                  <div className="absolute inset-0 bg-gradient-to-t from-background-100/90 via-transparent to-transparent"></div>
                </div>
                <div className="p-4">
                  <div className="flex items-center gap-2 mb-2">
                    <span className="text-xs text-accent-400 font-medium whitespace-nowrap">{card.tag}</span>
                  </div>
                  <h3 className="font-heading font-bold text-base text-foreground-100 mb-2 group-hover:text-primary-400 transition-colors">
                    {card.title}
                  </h3>
                  <p className="text-xs text-foreground-500 leading-relaxed line-clamp-2">{card.desc}</p>
                </div>
              </div>
            </a>
          ))}
        </div>

        <div className="flex lg:hidden justify-center mt-4">
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-5 w-full">
            {cards.slice(3).map((card) => (
              <a key={card.title} href="#cards" onClick={(e) => e.preventDefault()} className="group block cursor-pointer">
                <div className="bg-background-100 rounded-xl overflow-hidden border border-background-300/20 transition-all duration-300 hover:border-primary-500/30">
                  <div className="relative aspect-[16/10] overflow-hidden">
                    <img
                      src={card.img}
                      alt={card.title}
                      className="w-full h-full object-cover object-center transition-transform duration-500 group-hover:scale-105"
                    />
                    <div className="absolute top-3 left-3">
                      <span className="px-2 py-0.5 bg-accent-500 text-background-50 text-xs font-medium rounded-md whitespace-nowrap">
                        {card.badge}
                      </span>
                    </div>
                    <div className="absolute inset-0 bg-gradient-to-t from-background-100/90 via-transparent to-transparent"></div>
                  </div>
                  <div className="p-4">
                    <div className="flex items-center gap-2 mb-2">
                      <span className="text-xs text-accent-400 font-medium whitespace-nowrap">{card.tag}</span>
                    </div>
                    <h3 className="font-heading font-bold text-base text-foreground-100 mb-2 group-hover:text-primary-400 transition-colors">
                      {card.title}
                    </h3>
                    <p className="text-xs text-foreground-500 leading-relaxed line-clamp-2">{card.desc}</p>
                  </div>
                </div>
              </a>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}